import React, { useState } from "react";
import { useParams } from "react-router-dom";
import AppRolePrivileges from "@/components/privileges/appRolePrivileges/AppRolePrivileges";

const AppRolePrivilegesPage = () => {
  const { appId, roleId } = useParams();
  const [roleName, setRoleName] = useState<string>("");

  const handleRoleLoaded = (name: string) => {
    setRoleName(name);
  };

  return (
    <>
      <AppRolePrivileges
        ApplicationId={Number(appId)}
        RoleId={Number(roleId)}
        ShowOnlyNewRolePrivilegePanel={false}
        onRoleLoaded={handleRoleLoaded}
        breadcrumbTitle="Application | Role | Privileges"
        breadcrumbSubtitle={
          roleName ? (
            <>
              Manage privileges for role <strong>{roleName}</strong>
            </>
          ) : (
            "Manage privileges for this role"
          )
        }
        backPath={`/applications/${appId}/roles`}
      />
    </>
  );
};

export default AppRolePrivilegesPage;
